import React from 'react';
import ArticulationCard from './ArticulationCard';
import StatsBar from './StatsBar';
import { getScoreTypeStats, groupDeliverablesByArticulation } from '../data/mockProject';

const DeliverableGroup = ({
  scoreType,
  deliverables,
  explanation,
  project,
  slug,
  accessToken,
  onUploadComplete,
  portalUploadBlockedReason = null,
  previewLimitReason = null,
}) => {
  const stats = getScoreTypeStats(project, scoreType);
  const allApproved = stats.approved === stats.total;
  
  // Group deliverables into articulations with dynamics
  const articulations = groupDeliverablesByArticulation(deliverables);

  return (
    <section className={`deliverable-group ${allApproved ? 'group-complete' : ''}`}>
      {/* Sticky header with title and stats */}
      <header className="group-header">
        <h2 className="group-name">{scoreType}</h2>
        <StatsBar stats={stats} />
      </header>

      {/* Group introduction/explanation - flat on background */}
      {explanation && (
        <div className="group-intro">
          {explanation.split('\n\n').map((paragraph, idx) => (
            <p key={idx}>{paragraph}</p>
          ))}
        </div>
      )}

      {/* Articulation cards - each contains its dynamics */}
      <div className="articulations-list">
        {articulations.map((articulation, index) => (
          <ArticulationCard 
            key={articulation.id} 
            articulation={articulation}
            number={index + 1}
            scoreType={scoreType}
            slug={slug}
            accessToken={accessToken}
            onUploadComplete={onUploadComplete}
            portalUploadBlockedReason={portalUploadBlockedReason}
            previewLimitReason={previewLimitReason}
            previewOnFirstDynamic={index === 0}
          />
        ))}
      </div>
    </section>
  );
};

export default DeliverableGroup;
